/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import arrowLeft from '../../assets/images/svg/left-arrow-gray.svg';
import arrowRight from '../../assets/images/svg/right-arrow-green.svg';
import { HeadingDescVsmall } from '../Headings';
import './customCalender.css';

const calenderData = [
  {
    date: '01-05-2022',
    data: ['01:00 PM', '01:30 PM', '01:45 PM', '02:00 PM']
  },
  {
    date: '02-05-2022',
    data: ['01:00 PM', '01:30 PM', '01:45 PM', '02:00 PM']
  },
  { date: '03-05-2022', data: ['01:45 PM', '02:00 PM'] }
];

function CustomCalender() {
  const [key, setKey] = useState(calenderData[0].date);
  return (
    <div className="calenderContainer">
      <div className="calenderBtns">
        <button type="button">
          <img src={arrowLeft} alt="leftArrow" />
        </button>
        <button type="button">
          <img src={arrowRight} alt="leftArrow" />
        </button>
      </div>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        {calenderData.map((calenderSingleData, index) => {
          const { date, data } = calenderSingleData;
          return (
            <Tab key={index} eventKey={date} title={date}>
              <ul className="timeContainer">
                {data.map((time) => (
                  <li key={time}>
                    <div className="custom__radio">
                      <input type="radio" name="custom" id={time} />
                      <label htmlFor={time}>
                        <HeadingDescVsmall text={time} />
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </Tab>
          );
        })}
      </Tabs>
    </div>
  );
}

export default CustomCalender;
